package tta.destinigo.talktoastro.feature_profile.transaction_history.data.di

import org.koin.dsl.module
import tta.destinigo.talktoastro.feature_profile.transaction_history.data.domain.TransactionInfoRepo
import tta.destinigo.talktoastro.feature_profile.transaction_history.data.remote.TransactionHistoryApiService

val transactionHistoryModel = module {
    single { TransactionHistoryApiService() }
    single { TransactionInfoRepo(get()) }
}